import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
  DailyFeedbackReportsAggregationData,
  DailyFeedbackReportsContentData,
  DailyFeedbackReportsMarketplaceData
} from "../../types/daily-feedback-reports-page.types";
import { MarketplaceKeyType } from "../../types/daily-feedback-reports-row.types";
import { ratingValueType } from "../../configs/daily-feedback-reports-row-config";
import { UtilityService } from "../../../../../core/services/utility.service";

@Component({
  selector: 'app-daily-feedback-reports-rating',
  standalone: true,
  templateUrl: './daily-feedback-reports-rating.component.html',
  styleUrls: [
    '../daily-feedback-reports-page-content/daily-feedback-reports-page-content.component.scss',
    './daily-feedback-reports-rating.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DailyFeedbackReportsRatingComponent {
  isAggregationRow = input<boolean>(false);
  type = input.required<MarketplaceKeyType>();
  marketplace = input.required<string>();
  data = input.required<DailyFeedbackReportsAggregationData | DailyFeedbackReportsContentData>();

  private utilityService: UtilityService = inject(UtilityService);

  public readonly ratingValueType = ratingValueType;

  public getStarsArray(rating: number): Array<number> {
    return Array(rating).fill(1);
  }

  public getRating(rating: number): string {
    const marketplaceKey = this.marketplace() as keyof DailyFeedbackReportsMarketplaceData;
    const marketplaceData = this.data()[marketplaceKey];

    if (!marketplaceData) { return '0'; }

    const type = `${this.marketplace()}${this.type()}Mark${rating}Quantity` as keyof typeof marketplaceData;

    const value = marketplaceData[type];
    return value > 0 ?
      this.utilityService.formatNumberForDisplay({
        value: value,
        numberSeparator: { separator: ' ' }
      }) :
      '0';
  }
}
